import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * The promoter's region-settings currency as an ISO code (e.g. 'GBP'), for
 * APIs that want a code rather than a symbol — `Intl.NumberFormat` in
 * particular. Returns undefined when unset, which lets callers fall through to
 * their own default.
 *
 * The getter normalizes the stored value, so an object or stringified object
 * cannot reach `Intl` and throw a RangeError.
 *
 * The store access is guarded because several components using this are unit
 * tested without a vuex store installed, where `useStore()` returns undefined.
 */
export function useCurrencyCode(): ComputedRef<string | undefined> {
  const store = useStore()
  return computed(() => store?.getters?.['authModule/regionSettingsCurrency'] || undefined)
}
